<template>
  <article class="content-container">
    <HeadingWithIcon
      :icon="faqIcon"
      :iconAlt="$t('faq.title')"
      :title="$t('faq.title')" />
    <div class="faq-container">
      <template v-if="isThaiLanguage">
        <AskAndAnswer
          v-for="(question, index) in faq"
          :key="index"
          :question="question.title"
          :answer="question.answer" />
      </template>
      <template v-else>
        <AskAndAnswer
          v-for="(question, index) in faqEN"
          :key="index"
          :question="question.title"
          :answer="question.answer" />
      </template>
    </div>
  </article>
</template>

<script>
import AskAndAnswer from '@/components/AskAndAnswer.vue';
import faq from '@/questions/faq.json';
import faqEN from '@/questions/faq-en.json';
import HeadingWithIcon from '@/components/HeadingWithIcon.vue';

const faqIcon = require('@/assets/images/icons/faq.svg');

export default {
  data() {
    return {
      faqIcon,
      faq,
      faqEN,
    };
  },
  computed: {
    isThaiLanguage() {
      return this.$store.state.language === 'th';
    },
  },
  components: {
    AskAndAnswer,
    HeadingWithIcon,
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.faq-container {
  width: 98%;
  margin: $spacer auto;
}
</style>
